import { Controller } from '@hotwired/stimulus'

// Toggles child rows belonging to a parent row in a dense table.
// Parent trigger: data-action="click->expandable-rows#toggle" data-expandable-rows-key-param="<id>"
// Child rows:     data-expandable-rows-target="child" data-key="<id>" (hidden by default)
class ExpandableRowsController extends Controller {
  static targets = ['child'];

  toggle (event) {
    const key = event.params.key.toString()
    const row = event.currentTarget
    const open = row.classList.toggle('is-open')
    this.childTargets.forEach(child => {
      if (child.dataset.key === key) { child.hidden = !open }
    })
  }

  toggleAll (event) {
    const open = event.currentTarget.dataset.state !== 'open'
    event.currentTarget.dataset.state = open ? 'open' : 'closed'
    this.element.querySelectorAll('[data-expandable-rows-target="child"]').forEach(child => {
      child.hidden = !open
    })
    this.element.querySelectorAll('.is-expandable').forEach(row => {
      row.classList.toggle('is-open', open)
    })
  }
}

export default ExpandableRowsController
